import React from 'react'
import { connect } from 'react-redux'

import { AVAILABLE, STATUS_GLYPHICONS } from '../constants/status'
import { addFavorite, removeFavorite } from '../actions'
import { getSubscribers } from '../selectors'
import { subscriberFilter, subscriberSort } from '../helper/subscriber'

import Icon from '../components/Icon'
import SortableHeader from '../components/SortableHeader'
import SubscriberFilter from './SubscriberFilter'

class DestinationSelection extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            filter: {
                username: x => x !== props.caller.username,
                status: [AVAILABLE]
            }
        }
        this.onSort = this.onSort.bind(this)
        this.onFilterChanged = this.onFilterChanged.bind(this)
        this.onSelect = this.onSelect.bind(this)
    }
    onSort(sortInfo) {
        this.setState({ sortInfo })
    }
    onFilterChanged(filter) {
        this.setState({ filter })
    }
    onSelect(destination) {
        if (this.props.onSelect) {
            this.props.onSelect(destination)
        }
    }
    toggleFavorite(subscriber) {
        if (this.props.favorites && this.props.favorites.indexOf(subscriber.username) >= 0) {
            this.props.removeFavorite(subscriber.username)
        } else {
            this.props.addFavorite(subscriber.username)
        }
    }
    render() {
        const { sortInfo, filter } = this.state
        const { onSort, onFilterChanged } = this
        const { favorites = [] } = this.props
        let subscribers = this.props.subscribers
            .filter(subscriberFilter(filter))
            .sort(subscriberSort(sortInfo))
            .map(subscriber => Object.assign({}, subscriber, {
                isFavorite: favorites.indexOf(subscriber.username) >= 0
            }))
        if (!sortInfo) {
            subscribers = subscribers.sort((a, b) => b.isFavorite && !a.isFavorite ? 1 : -1)
        }
        return (
            <div className="destination-selection">
            <div>
                <div className="phone-number form-inline">
                    <div className="form-group">
                        <label htmlFor="site-filter">Call phone number: &nbsp; </label>
                        <input type="text" name="phoneNumber" className="form-control" placeholder="+41795552233" onChange={e => this.setState({ phoneNumber: e.target.value })} />
                    </div>
                    <div className="form-group">
                        <button onClick={() => this.onSelect(this.state.phoneNumber)} className="btn btn-default">OK</button>
                    </div>
                </div>
                <SubscriberFilter className="filter" {...{ filter, onFilterChanged }} showStatus={false} />
                <div className="header">
                    <div className="unit"><SortableHeader property="unit" title="Unit" {...{ sortInfo, onSort }} /></div>
                    <div className="status"><SortableHeader property="status" title="Status" {...{ sortInfo, onSort }} /></div>
                    <div className="username"><SortableHeader property="username" title="Username" {...{ sortInfo, onSort }} /></div>
                    <div className="name"><SortableHeader property="name" title="Name" {...{ sortInfo, onSort }} /></div>
                    <div className="site"><SortableHeader property="site_name" title="Site" {...{ sortInfo, onSort }} /></div>
                </div>
                </div>
                <div className="subscribers">
                    {subscribers.map(subscriber => {
                        let className = 'subscriber ' + subscriber.status.toLowerCase()
                        if (subscriber.isFavorite) className += ' favorite'
                        return (
                            <div key={subscriber.username} {...{ className }} onClick={() => this.onSelect(subscriber)}>
                                <div className="unit">{subscriber.unit}</div>
                                <div className="status">
                                    <Icon icon={STATUS_GLYPHICONS[subscriber.status]} title={subscriber.status} />
                                </div>
                                <div className="username">{subscriber.username}</div>
                                <div className="name">{subscriber.name}</div>
                                <div className="site" title={subscriber.site_name}>{subscriber.site_name.split(',')[0]}</div>
                                <a className="star" onClick={e => { e.stopPropagation(); this.toggleFavorite(subscriber); }}><Icon icon="star" /></a>
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        subscribers: getSubscribers(state),
        favorites: state.preferences.favorites
    }
}

export default connect(mapStateToProps, { addFavorite, removeFavorite })(DestinationSelection)


// WEBPACK FOOTER //
// ./containers/DestinationSelection.jsx